import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { events } from '@/mocks/events';

const heroCollage = 'https://readdy.ai/api/search-image?query=editorial%20news%20evidence%20archive%20collage%20on%20warm%20cream%20paper%2C%20stacked%20documents%20receipts%20recordings%20with%20vermilion%20red%20rubber%20stamp%20seals%2C%20documentary%20high%20contrast%2C%20dramatic%20lighting%2C%20cinematic%20archival%20aesthetic&width=900&height=1200&seq=hero-archival-2026&orientation=portrait';

export default function Hero() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const materialCount = events.reduce((n, e) => n + e.materials.length, 0);
  const debunkCount = events.filter((e) => e.status === '辟谣中' || e.status === '已辟谣').length;

  return (
    <section className="relative overflow-hidden">
      {/* 右侧档案氛围底 */}
      <div className="pointer-events-none absolute -right-24 top-10 hidden xl:block w-[420px] h-[420px] rounded-full bg-primary-100/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 hidden xl:block w-[380px] h-[380px] rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="relative max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 py-10 md:py-14">
        {/* 文案区 */}
        <div className="lg:col-span-7 flex flex-col justify-center">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-archive-drawer-line"></i>吃瓜素材 · 归拢成档
            </span>
            <span className="inline-flex items-center gap-1.5 text-xs text-accent-700 bg-accent-100 px-3 py-1 rounded-full">
              <i className="ri-flag-2-line"></i>中立整理 · 不站队
            </span>
          </div>

          <h1 className="mt-5 font-display font-black text-foreground-950 leading-[1.1] text-[38px] md:text-[54px] tracking-tight">
            吃瓜不站队，
            <br />
            看证据<span className="text-primary-600">说话</span>
          </h1>
          <p className="mt-5 max-w-xl text-foreground-600 leading-relaxed text-[15px] md:text-base">
            69爆料专注实锤证据整理与事件档案汇总：把散落的聊天截图、转账记录、录音影像按
            <strong className="text-foreground-950">事件、人物、时间</strong>归拢成可检索的证据库，逐条标注来源，
            持续补档更新，并同步收录<span className="text-accent-700 font-medium">辟谣反锤</span>内容，帮你分辨真假信息。
          </p>

          {/* 检索框 */}
          <form
            className="mt-7 flex flex-col sm:flex-row gap-2 sm:gap-0 items-stretch sm:items-center sm:rounded-full sm:overflow-hidden border border-background-300 bg-background-100/70 sm:bg-background-50 sm:pr-1 sm:pl-4 sm:py-1 focus-within:border-primary-400"
            onSubmit={(e) => {
              e.preventDefault();
              navigate(`/archive${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ''}`);
            }}
          >
            <div className="flex items-center gap-2 sm:gap-0">
              <i className="ri-search-line text-foreground-500 px-1 sm:px-0 sm:pr-2"></i>
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                className="flex-1 bg-transparent text-sm md:text-base outline-none placeholder:text-foreground-400 py-2.5"
                placeholder="输入事件关键词 / 人物 / 素材类型，如：转账、录音"
                aria-label="检索证据库"
              />
            </div>
            <button
              type="submit"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium rounded-full px-6 py-2.5 whitespace-nowrap transition-colors mt-2 sm:mt-0"
            >
              <i className="ri-search-line md:hidden mr-1"></i>立即检索
            </button>
          </form>

          {/* 快速标签 */}
          <div className="mt-4 flex flex-wrap items-center gap-2 text-xs text-foreground-600">
            <span className="text-foreground-400">热门：</span>
            {['转账记录', '录音文件', '聊天截图', '辟谣反锤', '退费纠纷'].map((t) => (
              <button
                key={t}
                onClick={() => navigate(`/archive?q=${encodeURIComponent(t)}`)}
                className="px-3 py-1 rounded-full bg-background-100 hover:bg-secondary-100 hover:text-secondary-900 border border-background-200 transition-colors cursor-pointer"
              >
                {t}
              </button>
            ))}
          </div>

          {/* 统计 */}
          <dl className="mt-8 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { n: `${events.length * 12}+`, l: '收录事件档案' },
              { n: `${materialCount * 6}+`, l: '整理原始素材' },
              { n: `${debunkCount}组`, l: '辟谣反锤对质' },
            ].map((s) => (
              <div key={s.l} className="border-l-2 border-primary-500 pl-3">
                <dt className="sr-only">{s.l}</dt>
                <dd className="font-display font-black text-foreground-950 text-2xl md:text-3xl">{s.n}</dd>
                <dd className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{s.l}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 视觉拼贴 */}
        <div className="lg:col-span-5 relative hidden md:block">
          <div className="relative ml-auto w-[300px] md:w-[340px] xl:w-[380px]">
            <div className="absolute -left-10 top-8 hidden lg:block w-40 h-40 rounded-full border border-secondary-300"></div>
            <div className="relative rounded-lg overflow-hidden border-4 border-background-50 shadow-xl">
              <img
                src={heroCollage}
                alt="69爆料证据档案素材拼贴"
                title="69爆料实锤证据档案"
                className="w-full h-[440px] md:h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 to-transparent"></div>
              <div className="absolute bottom-5 left-5 right-5">
                <span className="stamp text-xs font-bold px-2 py-0.5 bg-background-50/20">EVIDENCE FILE</span>
                <p className="mt-2 text-background-100 text-sm leading-snug max-w-[220px]">
                  素材可溯 · 脱敏处理 · 逐条标源
                </p>
              </div>
            </div>
            <div className="absolute -left-24 bottom-4 hidden xl:flex items-center gap-2 bg-background-50 border border-background-200 rounded-lg px-3 py-2 text-xs shadow-sm">
              <i className="ri-shield-check-line text-accent-600"></i>
              <span className="text-foreground-700 whitespace-nowrap">来源可溯 · 反锤并列</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}